<app-banner [heading]="'ACTIVITY SCHEDULE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main"><!-- ======= Recent Activities Section ======= -->
    <section class="events" id="events">
    <div class="container" data-aos="fade-up">
    <div class="row">
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="..." src="assets/img/calendar/activity-planner.jpg"></div>
    
    <div class="card-body">
    <h5 class="card-title"><a href="https://drive.google.com/file/d/1LcI2-axiJ_ckqTGG_M54QnIrAUBlem-i/view?usp=sharing" target="_blank">ACTIVITY PLANNER </a></h5>
    <a href="https://drive.google.com/file/d/1LcI2-axiJ_ckqTGG_M54QnIrAUBlem-i/view?usp=sharing" target="_blank">View &amp; Download</a></div>
    </div>
    </div>
    
    <div class="col-md-8 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="..." src="assets/img/showcase/6.jpeg"></div>
    </div>
    </div>
    </div>
    </div>
    </section>
    <!-- End Recent Activities Section --></main>